import { ChangeEvent, Dispatch, SetStateAction, useEffect } from 'react';
import { AdditionalSendPedigreeData } from '../../common/types/models';
import M from 'materialize-css';

interface IProps {
  additionalData: AdditionalSendPedigreeData;
  setAdditionalData: Dispatch<SetStateAction<AdditionalSendPedigreeData>>;
}

const AdditionalData = ({ additionalData, setAdditionalData }: IProps) => {
  const onChange = ({
    target: { id, value },
  }: ChangeEvent<HTMLInputElement>) => {
    return setAdditionalData((prev: AdditionalSendPedigreeData) => ({
      ...prev,
      [id]: value,
    }));
  };

  useEffect(() => {
    M.updateTextFields();
  }, [additionalData]);

  return (
    <div className="card">
      <div className="card-content">
        <div className="row">
          <h6>
            Additional Information <span className="grey-text">(Optional)</span>
          </h6>
          <div className="divider" />
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              type="text"
              id="poNumber"
              value={additionalData?.poNumber || ''}
              onChange={onChange}
            />
            <label htmlFor="poNumber">PO Number</label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              type="text"
              id="invoiceNumber"
              value={additionalData?.invoiceNumber || ''}
              onChange={onChange}
            />
            <label htmlFor="invoiceNumber">Invoice Number</label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              type="text"
              id="advanceShipNotice"
              value={additionalData?.advanceShipNotice || ''}
              onChange={onChange}
            />
            <label htmlFor="advanceShipNotice">Advance Ship Notice</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalData;
